class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
   console.log('added');
    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });
    let reult = true;
    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then(response => {
                  if(response.ok) {
                     return response.json()
                   }
                   return response.json().then(json => {
                     reult = false;
                     console.log(json.description)
                     if(!document.querySelector('.cartFormError')){
                     let errDiv = document.createElement("div");
                      errDiv.append(json.description);
                     errDiv.classList.add('cartFormError');
                     this.closest('.product-form__input').append(errDiv);
                     }
                   })
      })
      .then((parsedState) => {
        this.cartNotification.renderContents(parsedState,reult );
        console.log(body,reult)
      })
      .catch((e) => {
        console.error(e);
        console.log(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        setTimeout(function(){
          if(document.querySelector('.cartFormError')) document.querySelector('.cartFormError').remove(); 
        }, 3000);
      });
  }
}

customElements.define('product-form', ProductForm);
